<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <p
      @click="copyContent(vending._id, 'ID da vending copiado!')"
      class="has-text-centered"
    >
      ID: {{ vending._id }}
      <b-icon icon="copy"></b-icon>
    </p>

    <h2 class="subtitle">
      {{ $t("vending.generalInfo") }}
    </h2>

    <div class="columns">
      <div class="column is-one-third">
        <b-field :label="$t('vending.vendingName')" label-position="on-border">
          <b-input
            v-model="vending.vendingInfo.name"
            placeholder="Ex: Vending cervejas"
            :disabled="
              vending.vendingInfo.isCacauShow || vending.vendingInfo.isDeco
            "
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('vending.vendingDescription')"
          label-position="on-border"
        >
          <b-input
            v-model="vending.vendingInfo.description"
            placeholder="Ex: Cervejas heineken"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-third">
        <b-field
          :label="$t('vending.supportCellphone')"
          label-position="on-border"
        >
          <vue-tel-input
            v-model="vending.vendingInfo.supportCellphone"
            class="input"
            :preferredCountries="['BR']"
            :inputOptions="{
              placeholder: 'Celular com DDD'
            }"
            :dropdownOptions="{
              showDialCodeInList: true,
              showDialCodeInSelection: true,
              showFlags: true
            }"
            validCharactersOnly
            @validate="vueTelValidate"
          ></vue-tel-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div v-if="vending._id">
          <hr />
          <h2 class="subtitle">
            Enviar comando
          </h2>

          <p style="color: green" v-if="socketConected === true">
            Socket conectado
          </p>

          <p style="color: red" v-else-if="socketConected === false">
            Socket desconectado
          </p>

          <b-select v-model="command" style="display: inline-block;">
            <option value="" disabled>Escolha...</option>
            <option value="test-socket">Testar socket (exibe toast)</option>
            <!-- <option value="close-app">Fechar App</option>
            <option value="exit-kiosk">Sair do modo quiosque</option> -->
            <option value="block-vending">Bloquear vending</option>
            <option value="unblock-vending">Desbloquear vending</option>
            <option value="is-vending-blocked">Verificar bloqueio</option>
            <option value="open-door">Abrir porta entrega</option>
            <option value="close-door">Fechar porta entrega</option>
          </b-select>

          <b-button
            class="is-warning"
            @click="sendCommandToVending()"
            :disabled="!socketConected"
          >
            Enviar
          </b-button>
          <br />
        </div>
      </div>
    </div>

    <b-field
      v-if="
        (companyInfo.isCacauShowHeadquarter &&
          !vending.vendingInfo.isCacauShow) ||
          (companyInfo.isDecoHeadquarter && !vending.vendingInfo.isDeco) ||
          (companyInfo.isSondaHeadquarter && !vending.vendingInfo.isSonda)
      "
    >
      <b-checkbox v-model="vending.vendingInfo.isAvailableToImport">
        {{ $t("vending.isAvailableToImport") }}
      </b-checkbox>
    </b-field>

    <div v-if="!vending.vendingInfo.isCacauShow && !vending.vendingInfo.isDeco">
      <hr />

      <h2 class="subtitle">
        {{ $t("vending.standbyVideo") }}
      </h2>

      <div class="columns">
        <div class="column is-narrow">
          <b-field>
            <b-checkbox v-model="vending.vendingConfig.playStandbyVideo">
              {{ $t("vending.playStandbyVideo") }}
            </b-checkbox>
          </b-field>
        </div>

        <div
          class="column is-one-third"
          v-if="vending.vendingConfig.playStandbyVideo"
        >
          <b-tooltip
            :label="$t('vending.playStandbyVideoAfterDescription')"
            multilined
            position="is-top"
          >
            <b-field
              :label="$t('vending.playStandbyVideoAfter')"
              label-position="on-border"
            >
              <b-input
                v-model="vending.vendingConfig.playStandbyVideoAfter"
                placeholder="10"
              ></b-input>
            </b-field>
          </b-tooltip>
        </div>
      </div>
    </div>

    <div v-if="!vending.vendingInfo.isCacauShow && !vending.vendingInfo.isDeco">
      <hr />

      <h2 class="subtitle">
        {{ $t("vending.timer") }}
      </h2>

      <div class="columns">
        <div class="column is-one-third">
          <b-tooltip
            :label="$t('vending.timerActiveTooltip')"
            multilined
            position="is-right"
          >
            <div class="block" style="position: relative; top: 10px;">
              <b-radio
                v-model="vending.vendingConfig.timer.timerActive"
                name="vending.vendingConfig.timer.timerActive"
                :native-value="true"
              >
                {{ $t("common.Active") }}
              </b-radio>

              <b-radio
                v-model="vending.vendingConfig.timer.timerActive"
                name="vending.vendingConfig.timer.timerActive"
                :native-value="false"
              >
                {{ $t("common.Inactive") }}
              </b-radio>
            </div>
          </b-tooltip>
        </div>

        <div class="column is-one-third">
          <b-tooltip
            :label="$t('vending.timeToBuyTooltip')"
            multilined
            position="is-top"
          >
            <b-field
              :label="$t('vending.timeToBuy')"
              label-position="on-border"
            >
              <b-input
                v-model="vending.vendingConfig.timer.timeToBuy"
                placeholder="60"
              ></b-input>
            </b-field>
          </b-tooltip>
        </div>

        <div class="column is-one-third">
          <b-tooltip
            :label="$t('vending.timeToWarnTooltip')"
            multilined
            position="is-top"
          >
            <b-field
              :label="$t('vending.timeToWarn')"
              label-position="on-border"
            >
              <b-input
                v-model="vending.vendingConfig.timer.timeToWarn"
                placeholder="10"
              ></b-input>
            </b-field>
          </b-tooltip>
        </div>
      </div>
    </div>

    <div v-if="!vending.vendingInfo.isCacauShow">
      <hr />

      <h2 class="subtitle">
        {{ $t("vending.purchase") }}
      </h2>

      <div class="columns">
        <div class="column is-narrow">
          <b-tooltip
            :label="$t('vending.itensPerPurchaseLimitTooltip')"
            multilined
            position="is-right"
          >
            <b-field
              :label="$t('vending.itensPerPurchaseLimit')"
              label-position="on-border"
            >
              <b-input
                v-model="vending.vendingConfig.itensPerPurchaseLimit"
                type="number"
                placeholder="10"
              ></b-input>
            </b-field>
          </b-tooltip>
        </div>

        <div class="column is-narrow">
          <b-tooltip
            :label="$t('common.clickIconToMoreInfo')"
            multilined
            position="is-right"
          >
            <b-field :label="$t('vending.status')" label-position="on-border">
              <b-select
                v-model="vending.vendingInfo.status"
                placeholder="Status"
              >
                <option value="active">{{ $t("settings.active") }}</option>
                <option value="showroom">{{ $t("settings.showroom") }}</option>
                <option value="underMaintenance">
                  {{ $t("settings.underMaintenance") }}
                </option>
              </b-select>

              <p
                class="control"
                style="cursor: pointer; padding-top: 7px; background-color: #f0f0f0; border-top-right-radius: 4px; border-bottom-right-radius: 4px; border-top: #ddd 1px solid; border-right: #ddd 1px solid; border-bottom: #ddd 1px solid;"
                @click="showStatusDetails = !showStatusDetails"
              >
                <b-icon icon="info-circle" type="is-info"></b-icon>
              </p>
            </b-field>
          </b-tooltip>
        </div>

        <div class="column is-narrow">
          <b-tooltip
            :label="$t('vending.criticalStockLevelTooltip')"
            multilined
            position="is-right"
          >
            <b-field
              :label="$t('vending.criticalStockLevel')"
              label-position="on-border"
              style="width: 190px"
            >
              <b-input
                v-model="vending.vendingConfig.criticalStockLevel"
                placeholder="30"
              ></b-input>
            </b-field>
          </b-tooltip>
        </div>

        <div class="column is-one-quarter">
          <b-tooltip
            :label="$t('vending.singleShipTooltip')"
            multilined
            position="is-top"
          >
            <b-field
              :label="$t('vending.singleShipDescription')"
              label-position="on-border"
              style="width: 200px;"
            >
              <b-radio
                v-model="vending.vendingConfig.isSingleShip"
                name="isSingleShip"
                :native-value="true"
                style="position: relative; top: 12px; left: 12px;"
              >
                {{ $t("common.yes") }}
              </b-radio>

              <b-radio
                v-model="vending.vendingConfig.isSingleShip"
                name="isSingleShip"
                :native-value="false"
                style="position: relative; top: 12px; left: 20px;"
              >
                {{ $t("common.no") }}
              </b-radio>
            </b-field>
          </b-tooltip>
        </div>
      </div>

      <div v-if="showStatusDetails" style="margin-bottom: 2rem;">
        <p>
          <u>{{ $t("settings.active") }}</u>
          -
          {{ $t("vending.activeExplanation") }}
        </p>

        <p>
          <u>{{ $t("settings.showroom") }}</u>
          -
          {{ $t("vending.showroomExplanation") }}
        </p>

        <p>
          <u>{{ $t("settings.underMaintenance") }}</u>
          -
          {{ $t("vending.underMaintenanceExplanation") }}
        </p>

        <p>
          <u>{{ $t("settings.inactive") }}</u>
          -
          {{ $t("vending.inactiveExplanation") }}
        </p>
      </div>
    </div>

    <div v-if="vending.vendingInfo.isCacauShow || vending.vendingInfo.isDeco">
      <hr />
      <h2 class="subtitle">
        {{ $t("vending.importPlanogram") }}
      </h2>

      <p v-show="[true, null].includes(noVendingsToImportCatalog)">
        {{ $t("vending.noVendingsToImportCatalog") }}
      </p>

      <div v-show="noVendingsToImportCatalog === false">
        <p>
          {{ $t("vending.importingCatalogWarning") }}
        </p>
        <br />

        <b-select
          id="vending-names-and-ids"
          v-model="catalogFromVending"
          style="display: inline-block;"
        ></b-select>

        <b-button class="is-warning" @click="importCatalogFromVending">
          {{ $t("vending.import") }}
        </b-button>
      </div>
    </div>

    <div
      v-if="
        vending.vendingConfig.acDevice &&
          vending.vendingConfig.acDevice.isActive
      "
    >
      <hr />

      <h2 class="subtitle">
        {{ $t("vending.acDevice") }}
      </h2>

      <div class="columns">
        <div class="column">
          <b-field label="IP" label-position="on-border">
            <b-input
              v-model="vending.vendingConfig.acDevice.ip"
              placeholder="192.168.0.51"
            />
          </b-field>
        </div>

        <div class="column">
          <b-field label="Usuário" label-position="on-border">
            <b-input
              v-model="vending.vendingConfig.acDevice.user"
              placeholder="admin"
            />
          </b-field>
        </div>

        <div class="column">
          <b-field label="Password" label-position="on-border">
            <b-input
              v-model="vending.vendingConfig.acDevice.password"
              placeholder="voltvolt"
            />
          </b-field>
        </div>

        <div class="column">
          <b-button class="is-warning" @click="resetVoltAcDeviceConfigs">
            {{ $t("vending.resetConfigs") }}
          </b-button>
        </div>
      </div>

      <div id="volt-ac-device-status">
        {{ miniPcStatus }}
        <br />
      </div>

      <b-field id="reset-poe-field" v-if="reguaSockets.length > 0">
        <b-button type="is-white" label="Tomada" disabled />
        <b-select id="poe-select" v-model="poeToReset">
          <option
            v-for="socket in reguaSockets"
            :key="socket.value"
            :value="socket.value"
          >
            {{ socket.title }}
          </option>
        </b-select>
        <p class="control">
          <b-button
            type="is-warning"
            label="Resetar"
            @click="resetVendingAcDevicePoe"
            :disabled="!poeToReset && poeToReset !== 0"
          />
        </p>
      </b-field>
      <span v-if="reguaSockets.length === 0 && minipcConnected">
        <br />
        <span style="color: red">Régua de tomadas não conectada</span>
        <br />
        <b-button
          type="is-warning"
          label="Tentar Novamente"
          @click="getVendingAcDeviceStatus"
        />
      </span>
    </div>
    <div
      v-if="
        (companyInfo.isCacauShowHeadquarter &&
          !vending.vendingInfo.isCacauShow) ||
          (companyInfo.isDecoHeadquarter && !vending.vendingInfo.isDeco) ||
          (companyInfo.isSondaHeadquarter && !vending.vendingInfo.isSonda) ||
          [
            '54.901.644/0001-80', // Mix Nutri
            '27.899.661/0001-57' // Mateus Ferrari
          ].includes(companyInfo.nationalCompanyId)
      "
    >
      <hr />

      <h2 class="subtitle">
        {{ $t("vending.customization") }}
      </h2>

      <p>{{ $t("vending.customizationInstructions") }}</p>
      <br />

      <div class="columns">
        <!-- Cor do fundo -->
        <div class="column">
          <b-field :label="$t('vending.backgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.backgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('backgroundColor', $event)"
            />
          </b-field>
        </div>

        <!-- Instruções -->
        <div class="column">
          <b-field :label="$t('vending.instructions')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.instructions"
              :color-formatter="colorFormatter"
              @input="changeColor('instructions', $event)"
            />
          </b-field>
        </div>

        <!-- Cor de fundo card produto -->
        <div class="column">
          <b-field :label="$t('vending.productCardBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.productCardBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('productCardBackgroundColor', $event)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <!-- Cor de fundo card categoria -->
        <div class="column">
          <b-field :label="$t('vending.categoryCardBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.categoryCardBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('categoryCardBackgroundColor', $event)"
            />
          </b-field>
        </div>

        <!-- Título da categoria -->
        <div class="column">
          <b-field :label="$t('vending.categoryTitleColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.categoryTitleColor"
              :color-formatter="colorFormatter"
              @input="changeColor('categoryTitleColor', $event)"
            />
          </b-field>
        </div>

        <!-- Borda categoria escolhida -->
        <div class="column">
          <b-field :label="$t('vending.chosenCategoryBorderColor')">
            <b-colorpicker
              :value="
                vending.vendingConfig.styles.chosenCategoryBackgroundColor
              "
              :color-formatter="colorFormatter"
              @input="changeColor('chosenCategoryBackgroundColor', $event)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <!-- Cor da fonte botões +/- -->
        <div class="column">
          <b-field :label="$t('vending.addRemoveItensFontColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.addRemoveItensFontColor"
              :color-formatter="colorFormatter"
              @input="changeColor('addRemoveItensFontColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor de fundo botões +/- -->
        <div class="column">
          <b-field :label="$t('vending.addRemoveItensBackgroundColor')">
            <b-colorpicker
              :value="
                vending.vendingConfig.styles.addRemoveItensBackgroundColor
              "
              :color-formatter="colorFormatter"
              @input="changeColor('addRemoveItensBackgroundColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor da fonte do total -->
        <div class="column">
          <b-field :label="$t('vending.totalFontColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.totalFontColor"
              :color-formatter="colorFormatter"
              @input="changeColor('totalFontColor', $event)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <!-- Cor da fonte botão pagar -->
        <div class="column">
          <b-field :label="$t('vending.totalBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.totalBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('totalBackgroundColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor da fonte botão cancelar -->
        <div class="column">
          <b-field :label="$t('vending.cancelFontColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.cancelFontColor"
              :color-formatter="colorFormatter"
              @input="changeColor('cancelFontColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor de fundo botão cancelar -->
        <div class="column">
          <b-field :label="$t('vending.cancelBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.cancelBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('cancelBackgroundColor', $event)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <!-- Cor da fonte botão pagar -->
        <div class="column">
          <b-field :label="$t('vending.payFontColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.payFontColor"
              :color-formatter="colorFormatter"
              @input="changeColor('payFontColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor de fundo botão pagar -->
        <div class="column">
          <b-field :label="$t('vending.payBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.payBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('payBackgroundColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor fonte botão adicionar itens -->
        <div class="column">
          <b-field :label="$t('vending.addMoreItensFontColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.addMoreItensFontColor"
              :color-formatter="colorFormatter"
              @input="changeColor('addMoreItensFontColor', $event)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <!-- Cor fundo botão adicionar itens -->
        <div class="column">
          <b-field :label="$t('vending.addMoreItensBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.addMoreItensBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('addMoreItensBackgroundColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor da fonte da descrição -->
        <div class="column">
          <b-field :label="$t('vending.descriptionFontColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.descriptionFontColor"
              :color-formatter="colorFormatter"
              @input="changeColor('descriptionFontColor', $event)"
            />
          </b-field>
        </div>

        <!-- Cor de fundo da descrição -->
        <div class="column">
          <b-field :label="$t('vending.descriptionBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.descriptionBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('descriptionBackgroundColor', $event)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <!-- Cor fundo do item no carrinho -->
        <div class="column">
          <b-field :label="$t('vending.cartItemBackgroundColor')">
            <b-colorpicker
              :value="vending.vendingConfig.styles.cartItemBackgroundColor"
              :color-formatter="colorFormatter"
              @input="changeColor('cartItemBackgroundColor', $event)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field :label="$t('vending.poweredBy')">
            <b-radio
              v-model="vending.vendingConfig.styles.poweredBy"
              name="poweredBy"
              native-value="white"
            >
              {{ $t("vending.white") }}
            </b-radio>

            <b-radio
              v-model="vending.vendingConfig.styles.poweredBy"
              name="poweredBy"
              native-value="black"
            >
              {{ $t("vending.black") }}
            </b-radio>
          </b-field>
        </div>

        <div class="column">
          <b-field :label="$t('vending.languages')">
            <b-checkbox
              v-model="
                vending.vendingConfig.styles.showEnglishTranslationOption
              "
            >
              {{ $t("vending.english") }}
            </b-checkbox>

            <b-checkbox
              v-model="
                vending.vendingConfig.styles.showSpanishTranslationOption
              "
            >
              {{ $t("vending.spanish") }}
            </b-checkbox>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field :label="$t('vending.maxLogoDimensions')"></b-field>

          <b-checkbox v-model="darkBackgroundForClientLogo">
            {{ $t("vending.changeToDarkBackground") }}
          </b-checkbox>

          <div
            :style="darkBackgroundForClientLogo ? 'backgroundColor: #333' : ''"
            style="margin-top: 1rem;"
          >
            <div
              v-if="vending.vendingConfig.styles.clientLogo"
              class="has-bg-img"
              :style="{
                backgroundImage: vending.vendingConfig.styles.clientLogo
                  ? `url(${vending.vendingConfig.styles.clientLogo})`
                  : ''
              }"
              @click="$refs.storeImage.click()"
            ></div>

            <div
              v-else
              class="has-bg-img"
              style="background-image: url(https://assets.onii.app/vending/logos/logo-smart-orange-outline.png);"
              @click="$refs.storeImage.click()"
            ></div>

            <input
              type="file"
              ref="storeImage"
              style="display: none"
              accept="image/png, image/jpeg, image/jpg"
              @change="uploadStoreImage"
            />
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="has-text-centered">
      <b-button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        @click="updateVending"
      >
        {{ $t("common.update") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      showStatusDetails: false,
      darkBackgroundForClientLogo: false,
      poeToReset: null,
      catalogFromVending: null,
      noVendingsToImportCatalog: null,
      minipcConnected: false,
      miniPcStatus: "Conectando...",
      reguaSockets: [],

      vending: {
        vendingInfo: {
          name: "",
          description: "",
          status: "",
          isAvailableToImport: false,
          supportCellphone: "",
          supportCountryCallingCode: ""
        },
        vendingConfig: {
          timer: {
            timerActive: true,
            timeToBuy: 60,
            timeToWarn: 10
          },
          itensPerPurchaseLimit: 10,
          styles: {
            backgroundColor: "#929292",
            clientLogo: "",
            instructions: "#ffffff",
            categoryTitleColor: "#424242",
            categoryCardBackgroundColor: "#ffffff",
            productCardBackgroundColor: "#ffffff",
            chosenCategoryBackgroundColor: "#f77c02",
            addRemoveItensFontColor: "#ffffff",
            addRemoveItensBackgroundColor: "#f77c02",
            totalFontColor: "#ffffff",
            totalBackgroundColor: "#f77c02",
            cancelFontColor: "#ffffff",
            cancelBackgroundColor: "#f77c02",
            payFontColor: "#ffffff",
            payBackgroundColor: "#f77c02",
            addMoreItensFontColor: "#ffffff",
            addMoreItensBackgroundColor: "#f77c02",
            descriptionFontColor: "#ffffff",
            descriptionBackgroundColor: "#f77c02",
            cartItemBackgroundColor: "#ffffff",
            poweredBy: "white",
            showEnglishTranslationOption: true,
            showSpanishTranslationOption: true
          },
          acDevice: {
            isActive: false,
            provider: "",
            ip: "",
            user: "",
            password: ""
          },
          playStandbyVideo: false,
          playStandbyVideoAfter: 10,
          criticalStockLevel: 30,
          isSingleShip: true
        }
      },
      isTelValid: false,
      socketConected: false,
      command: ""
    };
  },

  methods: {
    vueTelValidate(t) {
      this.vending.vendingInfo.supportCountryCallingCode = t.country.dialCode;
      this.isTelValid = t.valid;
    },

    componentToHex(c) {
      let hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    },

    rgbToHex(data) {
      return (
        "#" +
        this.componentToHex(data.red) +
        this.componentToHex(data.green) +
        this.componentToHex(data.blue)
      );
    },

    colorFormatter(color) {
      return color.toString("rgb");
    },

    changeColor(variable, data) {
      this.vending.vendingConfig.styles[variable] = this.rgbToHex(data);
    },

    updateVending() {
      this.isLoading = true;
      this.$store
        .dispatch("updateVending", {
          vending: JSON.parse(JSON.stringify(this.vending))
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: this.$t("vending.vendingUpdated"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
          this.$parent.$parent.close();
        });
    },

    uploadStoreImage(event) {
      const formData = new FormData();
      const file = event.target.files[0];

      if (
        file.type !== "image/png" &&
        file.type !== "image/jpg" &&
        file.type !== "image/jpeg"
      ) {
        this.alertError({ message: "FILE_EXTENSION_NOT_ALLOWED_PNG_JPG_JPEG" });
        return;
      }

      if (file.size > 200000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE_200" });
        return;
      }

      formData.append("file", file);
      formData.append("vendingId", this.vending._id);

      this.isLoading = true;
      this.$store
        .dispatch("uploadFile", {
          to: "upload-vending-client-logo",
          data: formData
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
            this.vending.vendingConfig.styles.clientLogo = null;
          } else {
            this.vending.vendingConfig.styles.clientLogo = res.data.payload;
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    resetVoltAcDeviceConfigs() {
      this.vending.vendingConfig.acDevice.ip = "192.168.0.51";
      this.vending.vendingConfig.acDevice.user = "admin";
      this.vending.vendingConfig.acDevice.password = "voltvolt";
    },

    getVendingAcDeviceStatus() {
      if (
        this.vending.vendingConfig.acDevice &&
        this.vending.vendingConfig.acDevice.isActive
      ) {
        this.minipcConnected = false;
        this.miniPcStatus = "Conectando...";

        this.$store
          .dispatch("getVendingAcDeviceStatus", this.vending._id)
          .then(res => {
            if (res.data.payload.data.info) {
              if (res.data.payload.data.info.device === "minipc") {
                this.miniPcStatus = "Mini PC conectado";
              } else {
                this.miniPcStatus =
                  "Dispositivo de controle de tomadas conectado";
              }

              this.minipcConnected = true;

              this.reguaSockets.splice(0, this.reguaSockets.length);
              for (
                let i = 0;
                i < Number(res.data.payload.data.info.numero_tomadas);
                i++
              ) {
                this.reguaSockets.push({ title: i + 1, value: i + 1 });
              }

              if (this.reguaSockets.length > 0) {
                this.reguaSockets.unshift({ title: "Todas", value: 0 });
              }
            } else {
              this.miniPcStatus = "Erro ao conectar";
              this.minipcConnected = false;
            }
          })
          .catch(() => {
            const el = document.getElementById("volt-ac-device-status");
            el.innerHTML = "Erro ao conectar";
            el.style.color = "red";
          });
      }
    },

    resetVendingAcDevicePoe() {
      this.poeToReset = Number(this.poeToReset);
      if (isNaN(this.poeToReset)) {
        this.alertError({ message: "INVALID_POE" });
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch("resetVendingAcDevicePoe", {
          vendingId: this.vending._id,
          poe: this.poeToReset
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            // document.getElementById("reset-poe-field").style.display = "none";
            // const el = document.getElementById("volt-ac-device-status");
            // if (el) {
            //   el.innerHTML = "Comando recebido!";
            //   el.style.color = "green";
            // }
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    importCatalogFromVending() {
      if (!this.catalogFromVending) {
        this.alertError({ message: "INVALID_VENDING" });
        return;
      }
      this.$buefy.dialog.confirm({
        message: `Tem certeza que deseja substituir o catálogo atual?`,
        confirmText: "Sim",
        cancelText: "Cancelar",
        onConfirm: () => {
          this.isLoading = true;
          this.$store
            .dispatch("importCatalogFromVending", {
              vendingId: this.vending._id,
              catalogFromVending: this.catalogFromVending
            })
            .then(res => {
              if (res.data.result === "error") {
                this.alertError(res.data);
              } else {
                this.$emit("get-vendings");
                this.$buefy.toast.open({
                  message: "Catálogo importado",
                  type: "is-success",
                  position: "is-bottom"
                });
              }
            })
            .catch(() => {
              this.alertError({ message: "UNEXPECTED_ERROR" });
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },

    getVendingNamesAndIds() {
      this.$store
        .dispatch("getVendingNamesAndIds")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            const vendings = res.data.payload.vendings;

            if (vendings.length === 0) {
              this.noVendingsToImportCatalog = true;
              return;
            } else {
              this.noVendingsToImportCatalog = false;
            }

            const el = document.getElementById("vending-names-and-ids");
            let html = `<option value="">Escolha a vending que deseja importar o catálogo</option>`;

            for (let i = 0; i < vendings.length; i++) {
              if (vendings[i]._id !== this.vending._id) {
                html += `<option value=${vendings[i]._id}>${vendings[i].vendingInfo.name}</option>`;
              }
            }
            el.innerHTML = html;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    sendCommandToVending(command) {
      if (!command && !this.command) {
        this.alertError({ message: "CHOOSE_COMMAND" });
        return;
      }

      let data = null;

      if (this.command == "open-door") {
        command = "door-control";
        data = {
          doorOpen: true
        };
      } else if (this.command == "close-door") {
        command = "door-control";
        data = {
          doorOpen: false
        };
      }

      this.isLoading = true;
      this.$store
        .dispatch("sendCommandToVending", {
          vendingId: this.vending._id,
          command: command ? command : this.command,
          data
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
            if (command === "ping") {
              this.socketConected = false;
            }
          } else {
            if (command === "ping") {
              this.socketConected = true;
            } else if (
              this.command === "block-vending" ||
              this.command === "unblock-vending" ||
              this.command === "is-vending-blocked"
            ) {
              this.$buefy.toast.open({
                message: res.data.payload.isVendingBlocked
                  ? "Vending bloqueada"
                  : "Vending desbloqueada",
                type: "is-success",
                position: "is-bottom"
              });
            } else {
              this.$buefy.toast.open({
                message: "Comando recebido",
                type: "is-success",
                position: "is-bottom"
              });
            }
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["vendingBeingManaged", "companyInfo"])
  },

  mounted() {
    console.log(this.companyInfo);
    this.vending = this.vendingBeingManaged;
    this.getVendingAcDeviceStatus();
    if (
      this.vending.vendingInfo.isCacauShow ||
      this.vending.vendingInfo.isDeco
    ) {
      this.getVendingNamesAndIds();
    }
    if (this.vending._id) {
      this.sendCommandToVending("ping");
    }
  }
};
</script>

<style scoped>
.has-bg-img {
  background: center center;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
  height: 130px;
}
.has-bg-img:hover {
  opacity: 0.8;
}
</style>
